import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'LLM.Provider',
})
export class LLMProvider {
  @GenericLookup({
    code: 'LLM.Provider.OpenAI',
  })
  static openAI: number;

  @GenericLookup({
    code: 'LLM.Provider.Azure',
  })
  static azure: number;

  @GenericLookup({
    code: 'LLM.Provider.PrivateLLM',
  })
  static privateLLM: number;
}
